/**
 * assets/kits-cart-page.js — Cart line updates & upsell add (/cart)
 */
(function () {
  function closest(el, sel) {
    if (!el || !el.closest) return null;
    return el.closest(sel);
  }

  async function changeLine(key, quantity, itemEl) {
    if (itemEl) itemEl.classList.add('is-updating');
    try {
      var res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      });
      if (!res.ok) throw new Error('Cart change failed');
      window.location.reload();
    } catch (err) {
      console.error(err);
      if (itemEl) itemEl.classList.remove('is-updating');
    }
  }

  function initCartForm(root, cartForm) {
    cartForm.addEventListener('click', function (e) {
      var dec = closest(e.target, '[data-qty-decrease]');
      var inc = closest(e.target, '[data-qty-increase]');
      var rem = closest(e.target, '[data-remove-item]');

      if (dec) {
        var wrap = dec.closest('.ks-qty-selector');
        var input = wrap && wrap.querySelector('[data-qty-input]');
        if (!input) return;
        var v = Math.max(1, parseInt(input.value, 10) - 1);
        input.value = String(v);
        changeLine(input.getAttribute('data-line-key'), v, closest(dec, '.ks-cart-item'));
        return;
      }
      if (inc) {
        var wrap2 = inc.closest('.ks-qty-selector');
        var input2 = wrap2 && wrap2.querySelector('[data-qty-input]');
        if (!input2) return;
        var v2 = parseInt(input2.value, 10) + 1;
        input2.value = String(v2);
        changeLine(input2.getAttribute('data-line-key'), v2, closest(inc, '.ks-cart-item'));
        return;
      }
      if (rem) {
        var item = closest(rem, '.ks-cart-item');
        if (item) item.classList.add('is-removing');
        changeLine(rem.getAttribute('data-line-key'), 0, item);
      }
    });

    cartForm.addEventListener('change', function (e) {
      if (!e.target.matches('[data-qty-input]')) return;
      var input = e.target;
      var v = Math.max(1, parseInt(input.value, 10) || 1);
      input.value = String(v);
      changeLine(input.getAttribute('data-line-key'), v, closest(input, '.ks-cart-item'));
    });
  }

  function initUpsells(root) {
    root.addEventListener('click', function (e) {
      var btn = closest(e.target, '[data-upsell-add]');
      if (!btn || !root.contains(btn)) return;
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      btn.classList.add('is-loading');
      var label = btn.getAttribute('data-default-label') || btn.textContent.trim();
      btn.setAttribute('data-default-label', label);
      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Add failed');
          return r.json();
        })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btn.textContent = 'Added';
          window.setTimeout(function () {
            window.location.reload();
          }, 600);
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          btn.textContent = label;
        });
    });
  }

  function boot() {
    var root = document.querySelector('[data-ks-cart-page]');
    if (!root) return;
    var cartForm = root.querySelector('[data-cart-form]');
    if (cartForm) initCartForm(root, cartForm);
    initUpsells(root);

    if (cartForm && window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push({
        event: 'cart_view',
        ga4_section: 'cart_page',
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ============================================
   REVIEWS CAROUSEL CONTROLLER
   ============================================ */
(function () {
  function initReviewsCarousel() {
    var carousel = document.querySelector('[data-reviews-carousel]');
    if (!carousel) return;

    var cards = carousel.querySelectorAll('[data-review-card]');
    var prevBtn = carousel.querySelector('[data-reviews-prev]');
    var nextBtn = carousel.querySelector('[data-reviews-next]');
    var progressFill = carousel.querySelector('[data-reviews-progress]');

    if (!cards.length || !prevBtn || !nextBtn || !progressFill) return;

    var cardsPerView = window.innerWidth >= 750 ? 2 : 1;
    var totalCards = cards.length;
    var currentIndex = 0;

    function updateCarousel() {
      cards.forEach(function (card, index) {
        var isVisible = index >= currentIndex && index < currentIndex + cardsPerView;
        card.style.display = isVisible ? 'block' : 'none';
      });

      var progress = ((currentIndex + cardsPerView) / totalCards) * 100;
      progressFill.style.width = Math.min(progress, 100) + '%';

      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex + cardsPerView >= totalCards;
    }

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) {
        currentIndex -= cardsPerView;
        if (currentIndex < 0) currentIndex = 0;
        updateCarousel();
      }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex + cardsPerView < totalCards) {
        currentIndex += cardsPerView;
        updateCarousel();
      }
    });

    var resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        var newCardsPerView = window.innerWidth >= 750 ? 2 : 1;
        currentIndex = 0;
        updateCarousel();
      }, 200);
    });

    updateCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewsCarousel);
  } else {
    initReviewsCarousel();
  }
})();

/* ============================================
   FAQ ACCORDION CONTROLLER
   ============================================ */
(function () {
  function initFaqAccordion() {
    var accordion = document.querySelector('[data-faq-accordion]');
    if (!accordion) return;

    accordion.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-faq-trigger]');
      if (!trigger) return;

      var item = trigger.closest('[data-faq-item]');
      if (!item) return;

      var isOpen = item.classList.contains('is-open');

      accordion.querySelectorAll('[data-faq-item]').forEach(function (otherItem) {
        otherItem.classList.remove('is-open');
      });

      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqAccordion);
  } else {
    initFaqAccordion();
  }
})();

/* ============================================
   SMART STICKY CHECKOUT BAR
   Only shows when main checkout is not visible
   ============================================ */
(function () {
  'use strict';

  function initStickyCheckout() {
    // Find elements
    var mainCheckoutBtn = document.querySelector('.ks-cart-summary .ks-btn--checkout');
    var stickyBar = document.querySelector('.ks-mobile-checkout');

    // Validate both exist
    if (!mainCheckoutBtn) {
      console.warn('[Sticky Checkout] Main checkout button not found');
      return;
    }

    if (!stickyBar) {
      console.warn('[Sticky Checkout] Sticky checkout bar not found');
      return;
    }

    // Helper: Check if viewport is mobile
    function isMobile() {
      return window.innerWidth < 990;
    }

    // Helper: Hide sticky bar
    function hideStickyBar() {
      if (!stickyBar.classList.contains('is-hidden')) {
        stickyBar.classList.add('is-hidden');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
    }

    // Helper: Show sticky bar
    function showStickyBar() {
      if (stickyBar.classList.contains('is-hidden')) {
        stickyBar.classList.remove('is-hidden');
        stickyBar.setAttribute('aria-hidden', 'false');
      }
    }

    // Initialize: On desktop, always hide
    if (!isMobile()) {
      hideStickyBar();
      return;
    }

    // Intersection Observer options
    var observerOptions = {
      root: null, // viewport
      rootMargin: '-50px 0px 0px 0px', // Small offset from top
      threshold: [0, 0.1, 0.5, 1]
    };

    // Create observer to watch main checkout button
    var checkoutObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // If ANY part of checkout button is visible in viewport, hide sticky
        if (entry.isIntersecting && entry.intersectionRatio > 0) {
          hideStickyBar();
        } else {
          // Button is fully out of view, show sticky
          showStickyBar();
        }
      });
    }, observerOptions);

    // Start observing
    checkoutObserver.observe(mainCheckoutBtn);

    // Handle window resize: desktop should never show sticky
    var resizeTimer;
    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (!isMobile()) {
            hideStickyBar();
          }
        }, 250);
      },
      { passive: true }
    );

    // Initial check on load: if checkout is already visible, hide sticky
    var rect = mainCheckoutBtn.getBoundingClientRect();
    var isVisible = rect.top >= -50 && rect.bottom <= window.innerHeight;

    if (isVisible) {
      hideStickyBar();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyCheckout);
  } else {
    initStickyCheckout();
  }
})();

